import React from 'react';
import styled, { useTheme } from 'styled-components';

import Section from './SectionWrapper';
import MainButton from '@elements/MainButton';
import HubspotForm from '../PardotForm/HubspotForm';

import { DisplayLarge, BodyText18 } from '@styled-components/Typography';
import StyledTextBlocks from '@styled-components/StyledTextBlocks';

import CTABG from '@images/backgrounds/general_cta-bg.jpg';

const ContentWrapper = styled.div`
	text-align: center;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

const Heading = styled(DisplayLarge)`
	text-wrap: pretty;
	text-align: center;

	${props => props.theme.mediaQuery.breakpointLg} {
		max-width: ${props => props.maxHeaderWidth || 1000}px;
	}
`;

const SubHeading = styled(BodyText18)`
	text-align: center;

	${props => props.theme.mediaQuery.breakpointLg} {
		max-width: ${props => props.maxSubHeadWidth || 1000}px;
	}
`;

const TextHeading = styled.div`
	text-align: center;
	margin: 0 auto 2rem;
	color: ${props => props.theme.colors.black.main};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

const HubspotFormWrapper = styled.div`
	max-width: 872px;
	width: 100%;
`;

const CTABlock = ({
	headline,
	subhead,
	ctaButton,
	hubspotFormId,
	hubspotId,
	anchorLink,
	linkText,
	maxHeaderWidth,
	maxSubHeadWidth,
	customGradient,
	customBG,
	...props
}) => {
	const theme = useTheme();
	return (
		<Section
			backgroundImage={customBG || CTABG}
			backgroundColor={
				customGradient || theme.colors.customGradients.ctaGradient
			}
			{...props}
		>
			<ContentWrapper>
				<TextHeading>
					<Heading maxHeaderWidth={maxHeaderWidth}>{headline}</Heading>
					<SubHeading>
						<StyledTextBlocks
							maxSubHeadWidth={maxSubHeadWidth}
							textBlock={subhead}
							options={{ bodySize: 18 }}
						/>
					</SubHeading>
				</TextHeading>
				{ctaButton?.linkUrl && (
					<MainButton linkUrl={ctaButton?.linkUrl} anchorLink={anchorLink}>
						{ctaButton?.linkText || linkText}
					</MainButton>
				)}
				{hubspotFormId && <HubspotForm formId={hubspotFormId} />}
			</ContentWrapper>
		</Section>
	);
};

export default CTABlock;
